export default {
  instructions: 'Have your window treatments professionally measured and installed by an experienced service provider in your area. Enter your address below to check availability.',
};
